import React from 'react';
import useChatJourneyTwoPanel from './hooks/useChatJourneyTwoPanel';
import ChatJourneyTwoPanelView from './ChatJourneyTwoPanelView';

// HOC: injects all chat journey logic/state into presentational ChatJourneyTwoPanelView
function ChatJourneyTwoPanel() {
  const props = useChatJourneyTwoPanel();
  return <ChatJourneyTwoPanelView {...props} />;
}

export default ChatJourneyTwoPanel;
